import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import Nav from '../../common/Nav'
import '../Home/home.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import frame from '../../assets/Frame.png';
import frameModel from '../../assets/Image.png';
import { GooglePlayButton, AppStoreButton, ButtonsContainer, } from "react-mobile-app-button";
import Footer from '../../common/Footer';
import Counter from '../../common/counterCard';
import Memberships from '../MemberShip/Memberships';
import DestinationGallery from '../Destination/DestinationGallery';
import { FAQs, giftCards, newsAndEvents } from '../../common/data';
import { FaHeart, FaRegHeart } from 'react-icons/fa';
import { database, ref, onValue } from "../../auth/firebase";
import Slider from './Slider';
import Carousel from './Carousel';
import PayUButton from '../../common/PayNow';
import  gift1 from '../../assets/gift1.jpeg';
import  gift2 from '../../assets/gift2.jpeg';
import  gift3 from '../../assets/gift3.jpeg';
import  gift4 from '../../assets/gift4.jpeg';
import FloatingButton from '../../common/FloatingButton';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';



const Home = () => {
  const [activeFAQ, setActiveFAQ] = useState(null);
  const [likedItems, setLikedItems] = useState([]);
  const [hotels, setHotels] = useState([]);
  const navigate = useNavigate();
  const gifts = [{
    id: 1,
    image: gift1,
    title: 'Stay Gift Card',
    description: 'Relax and unwind at exotic beaches.',
  },
  {
    id: 2,
    image: gift2,
    title: 'Discount Voucher',
    description: 'Escape to serene mountain retreats.',
  },
  {
    id: 3,
    image: gift3,
    title: 'Flight Voucher',
    description: 'Discover urban landscapes and adventures.',
  },
  {
    id: 4,
    image: gift4,
    title: 'Cinema Voucher',
    description: 'Enjoy luxury and elegance at our resorts.',
  },
  {
    id: 5,
    image: gift4,
    title: 'Family Adventures',
    description: 'Create unforgettable memories with family.',
  },
  {
    id: 6,
    image: gift3,
    title: 'Weekend Getaways',
    description: 'Short escapes for rejuvenating weekends.',
  },
  {
    id: 7,
    image: gift2,
    title: 'Graduation Treats',
    description: 'Celebrate achievements with travel gifts.',
  },
  {
    id: 8,
    image: gift1,
    title: 'Corporate Retreats',
    description: 'Reward your team with unforgettable retreats.',
  },]

  const APKUrl =
    "https://play.google.com/store/apps/details?id=host.exp.exponent";
  const iOSUrl = "https://apps.apple.com/us/app/expo-go/id982107779";
  // const faqs = [
  //   { question: "What are the membership tiers?", answer: "We offer Silver, Gold, and Platinum tiers with increasing benefits and exclusive perks." },
  //   { question: "How long is the membership valid?", answer: "The membership is valid for one year and can be renewed annually." },
  //   { question: "Can I upgrade my membership?", answer: "Yes, you can upgrade your membership at any time to access more benefits." }
  // ];
  const toggleFAQ = (id) => {
    setActiveFAQ(activeFAQ === id ? null : id);
  };
  const redirectToGiftCardPage = () => {
    navigate('/giftcards'); // Update the route as per your app setup
  };

  const slides = [
    {
      title: "Travel,",
      topic:  'Wander. Discover. Repeat.',
      description: "Enjoy the sunset at this amazing beach with crystal clear water.Enjoy the sunset at this amazing beach with crystal clear water.",
      image: "https://i.pinimg.com/736x/6d/0a/7d/6d0a7d986c51591d139cb4b1769bb0bb.jpg",
      thumbnail: "https://i.pinimg.com/736x/ee/ec/23/eeec23d8811ceefe79b5f28ce5870c4e.jpg"
    },
    {
      title: "Mountain View",
      topic:  'Advanture Trips',
      description: "Breathtaking views of the mountains with fresh air and nature.Enjoy the sunset at this amazing beach with crystal clear water.",
      image: "https://i.pinimg.com/736x/80/a2/e5/80a2e57148366f9ae89510ff29a2c6e1.jpg",
      thumbnail: "https://i.pinimg.com/736x/80/a2/e5/80a2e57148366f9ae89510ff29a2c6e1.jpg"
    },
    {
      title: "City Lights",
      topic:  'Celebration Time',
      description: "Vibrant city life with amazing architecture and night lights.Enjoy the sunset at this amazing beach with crystal clear water.",
      image: "https://images.unsplash.com/photo-1477959858617-67f85cf4f1df",
      thumbnail: "https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?w=200"
    },
    {
      title: "City Lights",
      topic:  'Celebration Time',
      description: "Vibrant city life with amazing architecture and night lights.Enjoy the sunset at this amazing beach with crystal clear water.",
      image: "https://images.unsplash.com/photo-1477959858617-67f85cf4f1df",
      thumbnail: "https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?w=200"
    }
  ];
  useEffect(() => {
    const hotelsRef = ref(database, "data");
    onValue(hotelsRef, (snapshot) => {
      if (snapshot.exists()) {
        setHotels(Object.values(snapshot.val()));
      }
      console.log('hotel list :;;: ', hotels);

    });
    console.log('hotel list : ', hotels);
  }, [])
  const handleLike = (id) => {
    if (likedItems.includes(id)) {
      setLikedItems(likedItems.filter((item) => item !== id));
    } else {
      setLikedItems([...likedItems, id]);
    }
  };


  const handleSeeMore = () => { navigate('/news-and-events/2') };
  const redirectToNewsAndEventsPage = (id) => {
    console.log("......>>>>>", id)
    const eventId = id == null ? id : 2;
    //  navigate('/news-and-events/1'); // Update the route as per your app setup
  };
  return (
    <div className=" bg-box1  flex flex-col min-h-screen h-screen w-screen  max-h-max p-0 m-0">

      <div className='flex-grow bg-box1 relative pb-20'>
      <div className='px-6  '>
              <Nav />
            </div>
            {/* <Slider slides={slides}/> */}

            <Carousel/>
        {/* <TopBar /> */}
        {/* <img className=' absolute w-1/2  h-2/6 lg:h-1/2 right-0 p-0 m-0' src={frame} /> */}

        {/* <div className=' bg-box1 p-0 h-1/2 md:h-dvh w-full  mb-4	lg:mb-40   '>


          <div className='absolute p-0 md:p-6 pt-10 md:mt-6    right-0 left-0 '>
            <img src={frameModel} className='h-2/5 w-2/4  pt-24 float-right' />
            <div className='px-6 mb-24 '>
              <Nav />
            </div>
            <section className='mb-6'>
              <div className='  mt-2 pt-2  pb-4 mb-4'>

                <p className=" ml-5 text-start text-xl md:text-7xl font-bold text-black font-serif">Travel,<br></br>Enjoy and Discover your<br></br>world  your way.</p>
                <p className='mx-2 text-start md:text-2xl px-2 md:px-0'>Discover your next getaway with us! Whether you're dreaming of serene beaches, scenic mountains, or thrilling urban adventures, our travel portal offers a curated selection of experiences to inspire every type of traveler. Dive into exclusive deals, explore tailored holiday packages, and find the perfect stay at destinations across the globe. Let us help you plan an unforgettable journey filled with relaxation, excitement, and discovery. Your dream vacation is just a few clicks away!</p>
              </div>
              <div className='hidden md:flex bg-transparent lg:pt-8 md:px-12'>
                <ButtonsContainer>
                  <GooglePlayButton
                    url={APKUrl}
                    theme={"dark"}
                    className={"custom-style"}
                  />
                  <AppStoreButton
                    url={iOSUrl}
                    theme={"dark"}
                    className={"custom-style"}
                  />
                </ButtonsContainer>
              </div>

            </section>

          

          </div>
        </div> */}
        <div className=' bg-box1 membershipSection h-screen w-full  mt-0 lg:pt-32 lg:top-64 lg:top-0'>

          {/* <ImageCards/> */}
          
          {/* <div className=''>
            <Memberships isHome={true} />
          </div> */}


          {/* news and event section */}
          <section className='bg-box1 pt-0'>
            <div className="bg-box1  pb-12 px-4">
              <div className="max-w-max  mx-auto">
                {/* Section Header */}
                <h2 className="text-3xl font-bold text-gray-900 pb-12 text-center">
                  Latest News and Events
                </h2>

                {/* News and Events Grid */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                  {newsAndEvents.slice(0, 10).map((item) => (
                    <div
                      key={item.id}
                      onClick={redirectToNewsAndEventsPage(item.id)}
                      className="flex bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 cursor-pointer"
                    >
                      {/* Logo Image */}
                      <div className="w-1/4">
                        <img
                          src={item.logo}
                          alt={item.title}
                          className="w-full h-full object-cover rounded-l-lg"
                        />
                      </div>

                      {/* News/Event Details */}
                      <div className="flex-1 p-4">
                        <div className="flex items-center justify-between mb-2">
                          {/* Category Label */}
                          <span className="bg-blue-100 text-blue-600 text-xs font-medium px-3 py-1 rounded-lg">
                            {item.category}
                          </span>
                          {/* Like Button */}
                          <button
                            className="text-gray-500 hover:text-red-500 transition"
                            onClick={(e) => {
                              e.stopPropagation(); // Prevent triggering the card's redirect
                              handleLike(item.id);
                            }}
                          >

                            {likedItems.includes(item.id) ? (
                              <FaHeart className="text-red-500" />
                            ) : (
                              <FaRegHeart className="text-gray-400" />
                            )}
                          </button>
                        </div>

                        {/* Title */}
                        <h3 className="text-lg font-bold text-gray-800 mb-2">
                          {item.title}
                        </h3>

                        {/* Date & Time */}
                        <p className="text-sm text-gray-500">
                          {item.date} • {item.time}
                        </p>
                      </div>

                    </div>
                  ))}
                </div>

                {/* See More Button */}
                <div className="mt-8 text-center">
                  <button
                    onClick={handleSeeMore}
                    className="px-6 py-3 bg-blue-600 text-white rounded-lg shadow-lg hover:bg-blue-700 transition duration-300"
                  >
                    See More
                  </button>
                </div>
              </div>
            </div>
          </section>
          <section className='bg-box1  grid grid-rows-1 lg:grid-cols-3 gap-2 lg:flex-row'>
            <div className=' xs:flex  xs:justify-center p-8  lg:px-20 lg:pt-80'>
              <div className='flex  justify-center items-center   rounded-full w-52 h-52 md:w-96 md:h-96 box '>
                <div className=' bg-gray-100 flex  justify-center items-center rounded-full w-40 h-40  md:w-80 md:h-80  '>
                  <h1 className='text-gray-900 font-bold text-center font-sans'> OUR<br /> MISSION</h1>
                  {/* <h5>INFOGRAPHIC</h5> */}
                </div>
              </div>
            </div>
            <div className='md:col-span-1 lg:col-span-2 mt-14 lg:mt-0 pr-6'>
              <div>
                <div>

                </div>
                <div className=' bg-gray-100   lg:mx-8  md:mx-4 right-4 flex  rounded-xl md:rounded-full w-full  lg:w-5/6'>
                  <div className=' bg-box1 relative  pr-6 pt-12 md:pt-0 md:pr-24 left-0 border-y-2 border-l-2 md:border-y-8 md:border-l-8 border-gray-100 '>
                    <p className=' text-2xl md:text-4xl font-bold  pl-12 md:pl-32 md:pt-8  '> 01</p>
                    <div className=' absolute rounded-full  h-60  md:h-24 w-24 -skew-x-[0deg] md:w-60 flex items-center justify-center mx-0 mt-0 md:mx-2 md:mt-4  box '>
                      <p className='text-sky-400 text-4xl rotate-[270deg] md:rotate-[0deg] md:text-4xl font-bold font-sans  '  >Mission</p>
                    </div>
                  </div>

                  <div className='w-full lg:w-4/6 p-4 mr-0'>
                    <p className='font-normal text-lg '>INFOGRAPHIC</p>
                    <p className='font-bold text-2xl'> Pravasa.IN's Mission </p>
                    <p className='font-normal text-md  pr-10'>At Pravasa.IN, our mission is to inspire and create unforgettable travel experiences tailored to every explorer's dreams. We are committed to providing seamless, personalized, and enriching journeys that connect people with the world’s most breathtaking destinations.

                      With a focus on exceptional service, sustainability, and authentic cultural experiences, we strive to turn every trip into a cherished memory. Whether it’s a relaxing getaway, an adventurous expedition, or a luxurious retreat, we ensure stress-free planning and expert guidance at every step.

                      Let us take you on a journey where every moment is filled with discovery, wonder, and joy</p>
                  </div>

                </div>
              </div>
              <div>
                <div>

                </div>
                <div className=' bg-gray-100   md:m-4 lg:m-8 flex flex-col-2 rounded-xl md:rounded-full w-full  lg:w-5/6'>
                  <div className=' bg-box1 relative  pr-6 pt-12 md:pt-0 md:pr-24 left-0 border-y-2 border-l-2 md:border-y-8 md:border-l-8 border-gray-100 '>
                    <p className=' text-2xl md:text-4xl font-bold  pl-12 md:pl-32 md:pt-8  '> 02</p>
                    <div className=' absolute rounded-full  h-60  md:h-24 w-24 -skew-x-[0deg] md:w-60 flex items-center justify-center mx-0 mt-0 md:mx-2 md:mt-4  box '>
                      <p className='text-rose-400 text-4xl rotate-[270deg] md:rotate-[0deg] md:text-4xl font-bold font-sans  '  >Vision</p>
                    </div>
                  </div>

                  <div className='w-full lg:w-4/6 p-4  mr-0'>
                    <p className='font-normal text-lg '>INFOGRAPHIC</p>
                    <p className='font-bold text-2xl'> Pravasa.IN's Vision </p>
                    <p className='font-normal text-md pr-10'>At Pravasa.IN, we envision a world where travel is more than just a journey—it’s a transformative experience that connects people, cultures, and dreams. We aspire to be a leading travel partner, recognized for our commitment to excellence, innovation, and responsible tourism.

                      Our goal is to make travel seamless, sustainable, and enriching for all, ensuring that every traveler experiences the beauty of the world while preserving it for future generations. Through personalized service, cutting-edge technology, and a passion for exploration, we aim to redefine the way people discover the world.

                      Let’s create a future where every journey inspires, empowers, and brings people closer together.</p>
                  </div>

                </div>
              </div>
              <div>
                <div>

                </div>
                <div className=' bg-gray-100   md:m-4 lg:m-8 flex flex-col-2 rounded-xl md:rounded-full w-full  lg:w-5/6'>
                  <div className=' bg-box1   pr-6 pt-12 md:pt-0 md:pr-24 left-0 border-y-2 border-l-2 md:border-y-8 md:border-l-8 border-gray-100 '>
                    <p className=' text-2xl md:text-4xl font-bold  pl-12 md:pl-32 md:pt-8  '> 03</p>
                    <div className=' absolute rounded-full  h-60  md:h-24 w-24 -skew-x-[0deg] md:w-60 flex items-center justify-center mx-0 mt-0 md:mx-2 md:mt-4  box '>
                      <p className='text-orange-400 text-4xl rotate-[270deg] md:rotate-[0deg] md:text-4xl font-bold font-sans  '  >Value</p>
                    </div>
                  </div>

                  <div className='w-full lg:w-4/6 p-4 mr-0'>
                    <p className='font-normal text-lg '>INFOGRAPHIC</p>
                    <p className='font-bold text-2xl'> Values of Pravasa.IN </p>
                    <p className='font-normal text-md pr-10 py-10'>🌍 Passion for Travel – Inspiring meaningful adventures.<br />
                      🤝 Customer First – Personalized, seamless experiences.<br />
                      🌿 Sustainability – Promoting responsible tourism.<br />
                      ✨ Integrity – Honesty, transparency, and trust.<br />
                      🚀 Innovation – Embracing new solutions for excellence.<br />
                      🌏 Cultural Appreciation – Celebrating diversity and authentic experiences.<br />

                      We make every journey unforgettable!</p>
                  </div>

                </div>
              </div>
            </div>

          </section>
          {/* <div className='bg-gray-100 flex flex-col md:flex-row justify-center items-center  gap-4 py-20 px-10'>
            <div className='basis-1/2	'>
              <h1 className='pb-10'>What We Offer</h1>
              <ul className='list-disc flex flex-col items-start'>
                <li className=' flex-row'>
                  <h5 className='flex flex-row'>Tailored Itineraries:</h5>
                  <p>
                    Our travel specialists work closely with you to design customized itineraries that suit your interests, budget, and schedule.
                  </p>
                </li>
                <li>
                  <h5 className='flex flex-row'>Expert Advice:</h5>
                  <p>
                    With in-depth knowledge of global destinations, we provide insights and tips to enhance your travel experience                  </p>
                </li>
                <li>
                  <h5 className='flex flex-row'>Seamless Booking: </h5>
                  <p>
                    From flights and accommodations to tours and activities, we handle all the details, ensuring a stress-free booking process.                  </p>
                </li>
                <li>
                  <h5 className='flex flex-row'> 24/7 Support:</h5>
                  <p>
                    Your peace of mind is our priority. Our team is available around the clock to assist you during your travels, ensuring you have a safe and enjoyable journey.                  </p>
                </li>
              </ul>
            </div>
            <div className='basis-1/2	'>
              <h1 className='pb-10'>Our Values</h1>
              <ul className='list-disc '>
                <li className=''>
                  <h5 className='flex flex-row'>Customer-Centric:</h5> <p className='font-normal text-base'>
                    We prioritize your needs and preferences, ensuring every trip is personalized and memorable.                  </p>

                </li>
                <li>
                  <h5 className='flex flex-row'>Integrity:</h5>
                  <p>
                    We are committed to transparency and honesty, building trust with our clients through ethical practices.
                  </p>
                </li>
                <li>
                  <h5 className='flex flex-row'>Seamless Booking: </h5>
                  <p>
                    From flights and accommodations to tours and activities, we handle all the details, ensuring a stress-free booking process.
                  </p>
                </li>
                <li>
                  <h5 className='flex flex-row'>Sustainability:</h5>
                  <p>
                    We believe in responsible travel and strive to promote eco-friendly practices that benefit local communities and preserve the environment.                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div className=''>
            <div className=' p-12'>
              <div className='flex flex-col md:flex-row justify-center items-center  gap-4 pb-20 pt-20 h-full md:h-96 w-full'>
                <div className="mb-2 basis-1/2">
                  <h2 className="text-2xl font-semibold text-gray-800 mb-4">Our Mission</h2>
                  <p className="text-gray-600">
                    Our mission is to inspire and empower travelers by providing exceptional service, expert guidance, and personalized itineraries tailored to your unique preferences. Whether you're dreaming of a relaxing beach getaway, an adventurous mountain trek, or a cultural journey through vibrant cities, we are here to make your travel dreams a reality.
                  </p>
                </div>
                <div className='h-full w-4/5 md:h-96 md:w-96	shadow-2xl 	mb-12'>
                  <img className='w-full h-full 	shadow-2xl ' src='https://i.pinimg.com/236x/05/b1/0b/05b10bc874f4fd995da171ce3a5be09f.jpg'></img>
                </div>
              </div>
              <div className='flex flex-col md:flex-row justify-center items-center gap-4 pt-20 h-96 w-full'>
                <div className=' h-full w-4/5 md:h-96	md:w-96	shadow-2xl '>
                  <img className='w-full h-full 	shadow-2xl' src='https://i.pinimg.com/236x/31/08/2b/31082b936ec946630c93cafe0ba27799.jpg'></img>
                </div>
                <div className="mb-10 basis-1/2">
                  <h2 className="text-2xl font-semibold text-gray-800  mb-4">Join Us on Your Next Adventure!</h2>
                  <p className="text-gray-600 mb-20">
                    Whether you’re a seasoned traveler or planning your first trip, [Your Travel Agency Name] is here to guide you every step of the way. Let us help you discover new horizons and experience the beauty of the world.

                  </p>
                </div>

              </div>
            </div>
          </div> */}
          <section className='bg-box1 w-full'>
            <DestinationGallery />
          </section>
          {/* Testimonials Section */}
          <section className="py-12 bg-box1">
            <div className="container mx-auto px-4">
              <h2 className="text-2xl font-bold text-center mb-8">What Our Members Say</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
                {/* Testimonial 1 */}
                <div className="p-6 bg-white shadow-md rounded-lg text-center">
                  <p className="text-gray-600">"The best decision we've made! The membership has been worth every penny."</p>
                  <p className="text-lg font-bold mt-4">- Jai Singh</p>
                </div>
                {/* Testimonial 2 */}
                <div className="p-6 bg-white shadow-md rounded-lg text-center">
                  <p className="text-gray-600">"Amazing vacation spots and the customer service is top-notch."</p>
                  <p className="text-lg font-bold mt-4">- Abhinav Sharma</p>
                </div>
                {/* Testimonial 3 */}
                <div className="p-6 bg-white shadow-md rounded-lg text-center">
                  <p className="text-gray-600">"I love the flexibility and variety of destinations we can choose from!"</p>
                  <p className="text-lg font-bold mt-4">- Mahek Gupta</p>
                </div>
              </div>
            </div>
          </section>
          {/* Counter Section */}
          {/* <section className='bg-box1 w-screen'>
            <div className='bg-box1 flex flex-col  w-screen  items-center justify-start p-4 '>

              <h1 className=' hidden md:flex flex-col items-center  mb-0 pb-6'>Our Stats!!  </h1>
              <div className="flex flex-col w-screen md:flex-row items-center justify-center gap-4 lg:gap-10 p-0 lg:p-6  pt-0 bg-box1">
                <h1 className='md:hidden'>Our Stats!!  </h1>
                <Counter label="Trips" finalCount={2250} duration={2000} />
                <Counter label="Members" finalCount={8000} duration={4000} />
                <Counter label="Travelers" finalCount={10000} duration={100} />
              </div>
            </div>
          </section> */}
          {/* Gift Card Section Header */}
          <section className='bg-box1'>


            <h2 className="text-3xl font-bold text-center text-gray-900  py-8">
              Explore Gift Cards
            </h2>
            <p className="text-center text-gray-500 mb-12">
              Perfect gifts for every occasion. Plan your next adventure now!
            </p>

            {/* Gift Card Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {gifts.slice(0, 4).map((card) => (
                <div
                  key={card.id}
                  onClick={redirectToGiftCardPage}
                  className="relative overflow-hidden bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 cursor-pointer"
                >
                  {/* Card Image */}
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-48 object-fill"
                  />

                  {/* Hover Overlay */}
                  <div className="absolute inset-0 bg-black bg-opacity-50 opacity-1 hover:opacity-0 transition-opacity duration-300 flex items-center justify-center text-white p-4">
                    <h3 className="text-lg font-bold">{card.title}</h3>

                  </div>
                </div>
              ))}
            </div>

            {/* See More Button */}
            <div className="mt-8 text-center">
              <button
                onClick={() => redirectToGiftCardPage}
                className="px-6 py-3 bg-blue-600 text-white rounded-lg shadow-lg hover:bg-blue-700 transition duration-300"
              >
                See More
              </button>
            </div>
          </section>
          <FloatingButton />
          {/* FAQs Section */}
          <section className="py-12 bg-box1">
            <div className="container mx-auto px-4">
              <h2 className="text-2xl font-bold text-center mb-8">Frequently Asked Questions</h2>
              <div className="space-y-4">
                {FAQs.map((faq, index) => (
                  <div key={index} className="bg-white p-6 rounded-lg shadow-md cursor-pointer" onClick={() => toggleFAQ(index)}>
                    <div className="flex justify-between items-center">
                      <h4 className="text-lg font-bold">{faq.question}</h4>
                      <span>{activeFAQ === index ? '-' : '+'}</span>
                    </div>
                    {activeFAQ === index && <p className="mt-4 text-gray-600">{faq.answer}</p>}
                  </div>
                ))}
              </div>
            </div>
          </section>
          
          {/* <p className=" ml-5 text-start text-xl md:text-7xl font-DM text-black font-mono">Find Popular<br></br>Destinations.</p>

        <h1 className='txtHeading'>We Offers Best Services</h1>

        <div class="row row-cols-1 row-cols-md-5 g-8 ms-5 me-auto " >
          <div class="col w-20 shadow-lg p-3 mb-5 bg-body rounded ms-5">
            <div class="card h-100">
              <img src={restaurantIcon} class="card-img-top" alt="..." />
              <div class="card-body">
                <h5 class="card-title">Restaurants</h5>
                <p class="card-text">This is a longer card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
              </div>
            </div>
          </div>
          <div class="col w-20 shadow-lg p-3 mb-5 bg-body rounded ms-5">
            <div class="card h-100 ">
              <img src={flightIcon} class="card-img-top" alt="..." />
              <div class="card-body">
                <h5 class="card-title">Best Flights</h5>
                <p class="card-text">This is a longer card with supporting text below as a natural lead-in to additional content.</p>
              </div>
            </div>
          </div>

          <div class="col w-20 shadow-lg p-3 mb-5 bg-body rounded ms-5">
            <div class="card h-100">
              <img src={hotelIcon} class="card-img-top" alt="..." />
              <div class="card-body">
                <h5 class="card-title">Best Hotels</h5>
                <p class="card-text">This is a longer card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
              </div>
            </div>
          </div>
          <div class="col w-20 shadow-lg p-3 mb-5 bg-body rounded ms-5">
            <div class="card h-100 ">
              <img src={customizationIcon} class="card-img-top" alt="..." />
              <div class="card-body">
                <h5 class="card-title">Customizations</h5>
                <p class="card-text">This is a longer card with supporting text below as a natural lead-in to additional content.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='section-3'>
        <h6 className='txtSmallHeading'>Top Selling</h6>
        <h1 className='txtHeading'>Top Destinations</h1>
        <div class="card-group">
          <div class="card ms-5 shadow-lg p-3 mb-5 bg-body rounded">
            <img src={baliIcon} class="card-img-top h-75" alt="..." />
            <div class="card-body">
              <h5 class="card-title">Bali , Indonasia</h5>
              <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
              <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
            </div>
          </div>
          <div class="card ms-5 shadow-lg p-3 mb-5 bg-body rounded">
            <img src={jaipurIcon} class="card-img-top h-75" alt="..." />
            <div class="card-body">
              <h5 class="card-title">Jaipur , Rajasthan</h5>
              <p class="card-text">This card has supporting text below as a natural lead-in to additional content.</p>
              <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
            </div>
          </div>
          <div class="card ms-5 me-5 shadow-lg p-3 mb-5 bg-body rounded">
            <img src={goaIcon} class="card-img-top h-75" alt="..." />
            <div class="card-body">
              <h5 class="card-title">Goa , India</h5>
              <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This card has even longer content than the first to show that equal height action.</p>
              <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">

          <div className="col ">

            <div className="row ">
              <p className='float-start mb-0  txtSmallHeading'>Easy and Fast</p><br /><br />
              <p className='float-start pt-0 txtHeading '>Book Your Next Trip <br /> In 3 Easy Steps</p><br /><br />
              <div className="col-2">
                <img className='section3Img' src={restaurantIcon} />
              </div>
              <div className="col-9">
                <p className='float-start mb-0 txtSmallHeading'>Choose Destination</p>
                <p className='float-start pt-0'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
                  labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco .</p>
              </div>
            </div>
            <div className="row ">
              <div className="col-2">
                <img className='section3Img' src={restaurantIcon} />
              </div>
              <div className="col-9">
                <p className='float-start mb-0 txtSmallHeading'>Make Payment </p>
                <p className='float-start pt-0'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
                  labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco .</p>
              </div>
            </div>
            <div className="row">
              <div className="col-2">
                <img className='section3Img' src={restaurantIcon} />
              </div>
              <div className="col-9">
                <p className='float-start mb-0 txtSmallHeading'>Reach Airport on Selected Date</p>
                <p className='float-start pt-0'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
                  labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco .</p>
              </div>
            </div>

          </div>
          <div class="col">
            2 of 2
          </div>
        </div>
        <div className='row my-5'>
          <div className='col'>
            <p className='txtSmallHeading float-start mb-0'> Testimonials </p><br/><br/>
            <p className='txtHeading float-start pt-0 mb-5'> What People Say <br /> About Us.</p><br/><br/>
            
            
            </div>
            <div className='col'>

            </div>
          </div>
          <div className='row'> 
            <div id="carouselExampleDark" class="carousel carousel-dark slide pt-5" data-bs-ride="carousel">
              <div class="carousel-indicators">
                <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="1" aria-label="Slide 2"></button>
                <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="2" aria-label="Slide 3"></button>
              </div>
           </div>
            </div>
            <div className='frmBottom'>
              <p className='btmTxt'>Subscribe to get information , Latest news and other <br/> interesting offers about Pravasa!</p> <br/><br/>
              <input type='email' className='subscribeInput' placeholder='Your Email'></input>
              <button className='subscribeBtn'> Subscribe </button>

            </div>*/}
            <div>
             
            </div>
            
          <Footer />
        </div>
        {/* <Footer /> */}

      </div>

    </div>

  )
}
export default Home